import Divider from '@rio-cloud/rio-uikit/components/divider/Divider';
import Button from '@rio-cloud/rio-uikit/Button';
import { useAppDispatch } from '../../../../state/hooks';
import { openUserManualDialog } from '../../../../state/dialogs/useUserManualDialog';
import { userManualDialogChapters } from '../../../../state/dialogs/chapters';
import { FormattedMessage } from 'react-intl';
import { ClampedText } from '../../../../components/ClampedText';

export const Resources = () => {
  const dispatch = useAppDispatch();

  return (
    <div className="margin-top-25">
      <span className="padding-left-15">
        <FormattedMessage id="overview.resources.sectionTitle" />
      </span>
      <Divider />
      <div className="width-100pct display-flex flex-column align-items-center">
        <div className="text-size-20 text-medium">
          <FormattedMessage id="overview.resources.title" />
        </div>
        <ClampedText className="width-90pct width-66pct-sm text-center">
          <FormattedMessage id="overview.resources.text" />
        </ClampedText>
        <div className="margin-top-25 display-flex gap-20">
          <Button
            bsStyle="primary"
            data-testid="resources-help-function"
            onClick={() => {
              dispatch(
                openUserManualDialog(
                  userManualDialogChapters.getStartedWelcome,
                ),
              );
            }}
          >
            <FormattedMessage id="common.information.help" />
          </Button>
          {/* to implement with task MANSP-6802
          <Button
            bsStyle="primary"
            onClick={() => {

            }}
          >
            <FormattedMessage id="common.releaseNotes" />
          </Button> */}
        </div>
      </div>
    </div>
  );
};
